const mapStyle = [
  {
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#1c1b1b',
      },
    ],
  },
  {
    featureType: 'administrative',
    elementType: 'geometry',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'administrative.land_parcel',
    elementType: 'labels',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'administrative.neighborhood',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#1c1b1b',
      },
    ],
  },
  {
    featureType: 'landscape',
    stylers: [
      {
        color: '#e6eaf3',
      },
    ],
  },
  {
    featureType: 'poi',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'poi',
    elementType: 'labels.text',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'road',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#c2c3c4',
      },
      {
        weight: 1,
      },
    ],
  },
  {
    featureType: 'road',
    elementType: 'geometry.stroke',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'road',
    elementType: 'labels.icon',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'road.local',
    elementType: 'labels',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'transit',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'water',
    stylers: [
      {
        color: '#f7f7f7',
      },
    ],
  },
]

var infoWindow
var map

const panel = document.querySelector('#panel')

function initMap() {
  map = new google.maps.Map(document.getElementById('map'), {
    zoom: 2,
    center: { lat: 37.171229950590984, lng: -3.5981388035463437 },
    styles: mapStyle,
    mapTypeControl: false,
    fullscreenControl: false,
  })

  setMarkers(map)

  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const pos = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        }
        map.setCenter(pos)
      },
      () => {
        handleLocationError(true, map.getCenter())
      }
    )
  } else {
    // Browser doesn't support Geolocation
    handleLocationError(false, map.getCenter())
  }

  function handleLocationError(browserHasGeolocation, infoWindow, pos) {
    infoWindow.setPosition(pos)
    infoWindow.setContent(
      browserHasGeolocation
        ? 'Error: The Geolocation service failed.'
        : "Error: Your browser doesn't support geolocation."
    )
    infoWindow.open(map)
  }

  // Build and add the search bar
  const card = document.querySelector('#pac-card')
  const container = document.createElement('div')
  const input = document.createElement('input')
  const options = {
    types: ['address'],
    //componentRestrictions: {country: 'us'},
  }

  container.setAttribute('id', 'pac-container')
  input.setAttribute('id', 'pac-input')
  input.setAttribute('type', 'text')
  input.setAttribute('placeholder', 'Enter an address')
  container.appendChild(input)
  card.appendChild(container)

  // Make the search bar into a Places Autocomplete search bar and select
  // which detail fields should be returned about the place that
  // the user selects from the suggestions.
  const autocomplete = new google.maps.places.Autocomplete(input, options)

  autocomplete.setFields(['address_components', 'geometry', 'name'])

  const originIcon = {
    url: 'https://cdn.shopify.com/s/files/1/0020/0943/2153/t/40/assets/star1.png?v=15357695460528070633',
    scaledSize: new google.maps.Size(25, 25),
  }

  const originMarker = new google.maps.Marker({ icon: originIcon, map: map })
  originMarker.setVisible(false)
  let originLocation = map.getCenter()

  autocomplete.addListener('place_changed', async () => {
    originMarker.setVisible(false)
    originLocation = map.getCenter()
    const place = autocomplete.getPlace()

    if (!place.geometry) {
      // User entered the name of a Place that was not suggested and
      // pressed the Enter key, or the Place Details request failed.
      window.alert("No address available for input: '" + place.name + "'")
      return
    }

    // Recenter the map to the selected address
    originLocation = place.geometry.location
    map.setCenter(originLocation)
    map.setZoom(11)

    originMarker.setPosition(originLocation)
    originMarker.setVisible(true)

    // Use the selected address as the origin to calculate distances
    // to each of the store locations
    const rankedStores = await calculateDistances(mg_markers.locations, originLocation)
    showStoresList(mg_markers.locations, rankedStores)

    return
  })
}

var groupBy = function (xs, key) {
  return xs.reduce(function (rv, x) {
    ;(rv[x[key]] = rv[x[key]] || []).push(x)
    return rv
  }, {})
}

function sort_by_key(array, key) {
  return array.sort(function (a, b) {
    var x = a[key]
    var y = b[key]
    return x < y ? -1 : x > y ? 1 : 0
  })
}

function setMarkers(map) {
  const image = {
    url: 'https://cdn.shopify.com/s/files/1/0020/0943/2153/files/c-13.png?v=1581365943',
    scaledSize: new google.maps.Size(28, 28),
    anchor: new google.maps.Point(14, 20),
  }

  const locationsList = sort_by_key(mg_markers.locations, 'category')
  const groupedByCategory = groupBy(locationsList, 'category')

  Object.keys(groupedByCategory).forEach(function (category) {
    const listElement = document.createElement('div')
    listElement.classList.add('list-item')
    listElement.innerHTML = `<p class="category-name">${category}</p>`
    panel.appendChild(listElement)

    groupedByCategory[category].forEach(function (store) {
      const marker = new google.maps.Marker({
        position: { lat: store.coords[0], lng: store.coords[1] },
        map,
        icon: image,
        title: store.name,
      })

      infoWindow = new google.maps.InfoWindow()

      // Show the information for a store when its marker is clicked.
      marker.addListener('click', (event) => {
        openInfoWindowOnMarker(store)
      })

      const contentDiv = document.createElement('div')
      contentDiv.classList.add('list-item-content')
      contentDiv.innerHTML = `
        <div>
        <p>${store.name}</p>
        <p>${store.address}</br>
        ${store.address_2}</p>
        </div>
        `
      listElement.appendChild(contentDiv)

      contentDiv.addEventListener('click', () => {
        openInfoWindowOnMarker(store)
      })
    })
  })
}

function openInfoWindowOnMarker(store) {
  console.log(store)
  const position = { lat: store.coords[0], lng: store.coords[1] }
  const contentString = `
      <div class="info-window">
      <h2>${store.name}</h2>
      <p>${store.address}</br>
      ${store.address_2}</p>
      </div>
      `

  infoWindow.setContent(contentString)
  infoWindow.setPosition(position)
  infoWindow.setOptions({
    pixelOffset: new google.maps.Size(0, -15),
  })
  map.panTo(position)
  map.setZoom(14)
  infoWindow.open(map)
}

async function calculateDistances(data, origin) {
  const stores = []
  const destinations = []

  // Build parallel arrays for the store IDs and destinations
  data.forEach((store) => {
    const storeNum = store.id
    const storeLoc = { lat: store.coords[0], lng: store.coords[1] }

    stores.push(storeNum)
    destinations.push(storeLoc)
  })

  // Retrieve the distances of each store from the origin
  // The returned list will be in the same order as the destinations list
  const service = new google.maps.DistanceMatrixService()
  const getDistanceMatrix = (service, parameters) =>
    new Promise((resolve, reject) => {
      service.getDistanceMatrix(parameters, (response, status) => {
        if (status != google.maps.DistanceMatrixStatus.OK) {
          reject(response)
        } else {
          const distances = []
          const results = response.rows[0].elements
          for (let j = 0; j < results.length; j++) {
            const element = results[j]
            const distanceText = element.distance.text
            const distanceVal = element.distance.value
            const distanceObject = {
              storeid: stores[j],
              distanceText: distanceText,
              distanceVal: distanceVal,
            }
            distances.push(distanceObject)
          }

          resolve(distances)
        }
      })
    })

  const distancesList = await getDistanceMatrix(service, {
    origins: [origin],
    destinations: destinations,
    travelMode: 'DRIVING',
    unitSystem: google.maps.UnitSystem.METRIC,
  })

  distancesList.sort((first, second) => {
    return first.distanceVal - second.distanceVal
  })

  return distancesList
}

function showStoresList(data, stores) {
  if (stores.length == 0) {
    console.log('empty stores')
    return
  }

  let panel = document.createElement('div')
  // If the panel already exists, use it. Else, create it and add to the page.
  if (document.getElementById('panel')) {
    panel = document.getElementById('panel')
  }

  // Clear the previous details
  while (panel.lastChild) {
    panel.removeChild(panel.lastChild)
  }

  infoWindow.close()

  stores.forEach((store) => {
    const thisStore = data.filter((d) => d.id == store.storeid)
    const currentStore = thisStore[0]
    const contentDiv = document.createElement('div')
    contentDiv.classList.add('list-item-content')
    contentDiv.innerHTML = `
      <div>
      <p class="distanceText">${store.distanceText}</p>
      <p>${currentStore.name}</p>
      <p>${currentStore.address}</br>
      ${currentStore.address_2}</p>
      </div>
      `
    panel.appendChild(contentDiv)

    contentDiv.addEventListener(
      'click',
      (function (currentStore) {
        return function () {
          openInfoWindowOnMarker(currentStore)
        }
      })(currentStore)
    )
  })

  return
}
